// extracted by mini-css-extract-plugin
export var menu__dropDown = "DropDown-module--menu__dropDown--Vm-oF";
export var menu__dropDown_active = "DropDown-module--menu__dropDown_active--lumAj";
export var list = "DropDown-module--list--HpLdE";
export var list__item = "DropDown-module--list__item--0Rcb+";